import { Component, OnInit } from '@angular/core';
import { ModuloEnum } from '../../../shared/enums/modulo.enum';
import { FuncionalidadeEnum } from '../../../shared/enums/funcionalidade.enum';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { AlertService, AlertType } from '../../../shared/services/alert.service';
import { MatDialog } from '@angular/material/dialog';
import { MenuComponent } from '../../../shared/components/menu/menu.component';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { CommonModule } from '@angular/common';
import { MatTableModule } from '@angular/material/table';
import { MatSelectModule } from '@angular/material/select';
import { ActivatedRoute, Router } from '@angular/router';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { provideNgxMask } from 'ngx-mask';
import { Masks, MaskService } from '../../../shared/services/mask.service';
import { UsuarioAdminLookupResponse } from '../../../shared/services/responses/usuario-admin/usuario-admin-lookup.response';
import { CategoriaArquivoService } from '../../../shared/services/apis/integracao-arquivos/categoria-arquivo.service';
import { CategoriaArquivoResponse } from '../../../shared/services/responses/integracao-arquivos/categoria-arquivo.response';
import { ListaCategoriaArquivoResponse } from '../../../shared/services/responses/integracao-arquivos/lista-categoria-arquivo.response';
import { ArquivoService } from '../../../shared/services/apis/integracao-arquivos/arquivo.service';
import { ArquivoRequest } from '../../../shared/services/requests/integracao-arquivos/arquivo.request';
import { ArquivoUploadResponse } from '../../../shared/services/responses/integracao-arquivos/arquivo-upload.response';
import { MatChipsModule } from '@angular/material/chips';
import { MatAutocompleteModule, MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { ListaTagArquivoResponse } from '../../../shared/services/responses/integracao-arquivos/lista-tag-arquivo.response';
import { TagArquivo } from '../../../shared/services/models/integracao-arquivos/tag-arquivo.model';
import { map, Observable, startWith } from 'rxjs';
import { requiredTrim } from '../../../shared/validators/string-trim.validator';
import { ReturnStruct } from '../../../shared/services/structs/return.struct';

@Component({
  selector: 'app-arquivo-cadastro',
  imports: [
    MenuComponent,
    FormsModule,
    MatInputModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatIconModule,
    MatProgressSpinnerModule,
    CommonModule,
    MatTableModule,
    MatSelectModule,
    MatTooltipModule,
    MatSlideToggleModule,
    MatFormFieldModule,
    MatChipsModule,
    MatIconModule,
    MatAutocompleteModule,
  ],
  providers: [provideNgxMask()],
  templateUrl: './arquivo-cadastro.component.html',
  styleUrl: './arquivo-cadastro.component.css',
})
export class CadastroArquivoComponent implements OnInit {
  public moduloEnum: ModuloEnum;
  public funcionalidadeEnum: FuncionalidadeEnum;
  public model: FormGroup;
  public _isLoading: boolean = false;
  public _usuarioLookupResponse: UsuarioAdminLookupResponse;
  public _categoriaLookupResponse: ListaCategoriaArquivoResponse;
  public _categoriaArquivoResponse: CategoriaArquivoResponse;
  public _listaTagArquivoResponse: ListaTagArquivoResponse;
  public _listaTagArquivoPorCategoria: TagArquivo[] = [];
  public idCategoriaArquivo: number | null = null;
  public nomeEmpresaLogada: string;
  public masks: Masks;
  public formData = new FormData();
  public arquivoNome: string = '';

  // Propriedades para o controle da tag de arquivo (Chip com Autocomplete)
  public formControlTagArquivo = new FormControl({ value: '', disabled: true }, [Validators.required]);
  public separatorKeysCodesTagArquivo: number[] = [ENTER, COMMA];
  public selectedTagArquivo: TagArquivo | null = null;
  public filteredTagArquivo: Observable<TagArquivo[]>;

  constructor(
    private formBuilder: FormBuilder,
    private categoriaArquivoService: CategoriaArquivoService,
    private arquivoService: ArquivoService,
    private alertService: AlertService,
    private dialog: MatDialog,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private maskService: MaskService
  ) {
    this.moduloEnum = ModuloEnum.Desenvolvedor;
    this.funcionalidadeEnum = FuncionalidadeEnum.Desenvolvedor_Arquivo;
  }

  ngOnInit(): void {
    this.model = this.formBuilder.group({
      listaCategoriaArquivo: new FormControl('', [Validators.required]),
      tagArquivo: this.formControlTagArquivo,
      versao: new FormControl('', [Validators.required, requiredTrim]),
      uploadFile: new FormControl('', [Validators.required]),
    });

    this.popularLookup();
  }

  // Exibe o nome da tag no input do autocomplete
  displayTag(tag: TagArquivo): string {
    return tag && tag.nome ? tag.nome : '';
  }

  public onSelectedCategoriaArquivo(): void {
    this.selectedTagArquivo = null;
    // this.model.get('tagArquivo')?.setValue('');
    this.model.get('tagArquivo')?.reset();

    const idCategoria = this.model.get('listaCategoriaArquivo')?.value;

    if (idCategoria) {
      this.model.get('tagArquivo')?.enable();
      this._listaTagArquivoPorCategoria = this._listaTagArquivoResponse.listaTagArquivo.filter(
        tag => tag.idCategoriaArquivo === idCategoria
      );
    } else {
      this.model.get('tagArquivo')?.disable();
      this._listaTagArquivoPorCategoria = [];
    }

    this.filteredTagArquivo = this.formControlTagArquivo.valueChanges.pipe(
      startWith(''),
      map((value: string | TagArquivo | null) => {
        const filterValue =
          typeof value === 'string' ? value.toLowerCase() : (value?.nome?.toLowerCase() ?? '');

        return this._listaTagArquivoPorCategoria.filter(tag => tag.nome.toLowerCase().includes(filterValue));
      })
    );
  }

  // Quando o usuário seleciona uma tag do autocomplete
  onSelectedTagArquivo(event: MatAutocompleteSelectedEvent): void {
    const tag: TagArquivo = event.option.value;
    this.selectedTagArquivo = tag;
    // Armazena o ID da tag no controle "tagArquivo" para envio ao backend
    this.model.get('tagArquivo')?.setValue(tag.idTagArquivo);
    // Limpa o campo de entrada do autocomplete
    this.formControlTagArquivo.setValue('');
  }

  // Se o usuário remover a tag, limpa os valores
  removeTagArquivo(): void {
    this.selectedTagArquivo = null;
    this.model.get('tagArquivo')?.setValue('');
  }

  // Alteração de arquivo para upload
  onFileChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input && input.files && input.files.length > 0) {
      const file = input.files[0];
      this.formData = new FormData();
      this.formData.append('arquivoUpload', file);
      this.arquivoNome = file.name;
    }
  }

  // Realiza o submit do formulário
  submit(): void {
    if (this._isLoading || this.model.invalid) {
      return;
    }

    const arquivoRequest: ArquivoRequest = new ArquivoRequest();
    arquivoRequest.idCategoriaArquivo = this.model.get('listaCategoriaArquivo')?.value;
    // Envia o ID da tag selecionada
    if (this.selectedTagArquivo) {
      arquivoRequest.idTagArquivo = this.selectedTagArquivo.idTagArquivo;
    }

    arquivoRequest.versao = this.model.get('versao')?.value;
    const localArquivo = this.model.get('uploadFile')?.value;
    if (localArquivo) {
      arquivoRequest.nome = localArquivo.split('\\').pop() ?? '';
    }

    this.disableForm();

    if (this.formData.get('arquivoUpload')) {
      this.upload(this.formData, arquivoRequest);
    } else {
      this.alertService.show('Erro: ', 'Nenhum arquivo foi encontrado.', AlertType.error);
    }

    this.enableForm();
  }

  private disableForm(): void {
    this.model.get('listaCategoriaArquivo')?.disable();
    this.model.get('tagArquivo')?.disable();
    this.model.get('versao')?.disable();
    this.model.get('uploadFile')?.disable();
  }

  private enableForm(): void {
    this.model.get('listaCategoriaArquivo')?.enable();
    this.model.get('tagArquivo')?.enable();
    this.model.get('versao')?.enable();
    this.model.get('uploadFile')?.enable();
  }

  private upload(formData: FormData, arquivoRequest: ArquivoRequest): void {
    this._isLoading = true;
    this.arquivoService.uploadArquivo(arquivoRequest.idCategoriaArquivo, formData).subscribe({
      next: (response: ArquivoUploadResponse) => {
        this._isLoading = false;
        if (response.isError) {
          this.alertService.show('Erro', response.errorDescription, AlertType.error);
          return;
        }

        if (!response.localArquivo?.trim()) {
          this.alertService.show('Erro', 'O local do arquivo no FTP retornou vazio.', AlertType.error);
          return;
        }

        arquivoRequest.localArquivo = response.localArquivo;
        arquivoRequest.urlArquivoGCP = response.urlArquivoGCP;
        this.novo(arquivoRequest);
      },
      error: (error: any) => {
        this._isLoading = false;
        this.alertService.show('Erro inesperado', error.message, AlertType.error);
      },
    });
  }

  private novo(arquivoRequest: ArquivoRequest): void {
    this._isLoading = true;
    this.arquivoService.incluir(arquivoRequest).subscribe({
      next: (response: ReturnStruct) => {
        this._isLoading = false;
        if (response.isError) {
          this.alertService.show('Erro', response.errorDescription, AlertType.error);
          return;
        }

        this.alertService.show('Sucesso', 'Arquivo incluído com sucesso.', AlertType.success);
        this.router.navigate(['/desenvolvedor/arquivo']);
      },
      error: (error: any) => {
        this._isLoading = false;
        this.alertService.show('Erro inesperado', error.message, AlertType.error);
      },
    });
  }

  popularLookup(): void {
    this.categoriaArquivoService.lookup().subscribe({
      next: (response: ListaCategoriaArquivoResponse) => {
        if (response.isError) {
          this.alertService.show('Erro', response.errorDescription, AlertType.error);
          return;
        }
        this._categoriaLookupResponse = response;
      },
      error: (error: any) => {
        this.alertService.show('Erro inesperado', error.message, AlertType.error);
      },
    });

    this.categoriaArquivoService.lookupListaTagArquivo().subscribe({
      next: (response: ListaTagArquivoResponse) => {
        if (!response.isError) {
          this._listaTagArquivoResponse = response;
        }
      },
      error: (error: any) => {
        this.alertService.show('Erro inesperado', error.message, AlertType.error);
      },
    });
  }
}
